<script setup lang="ts">
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { mypageMenuList } from '@/constants/menu';
import { useAuthStore } from '@/stores/auth';
import { useTokenStore } from '@/stores/token';
// store
const route = useRoute();
const authStore = useAuthStore();
const tokenStore = useTokenStore();
const router = useRouter();
const currentMenuGroup = computed(() => {
	return route.path.split('/')[2];
});
const onClickLogout = () => {
	authStore.resetAuth();
	tokenStore.resetToken();
	router.push({ name: 'home' });
};
</script>

<template>
	<nav class="mypage_menu">
		<section class="user">
			<div class="user_info">
				<p>
					<b>{{ authStore.getMemberNickname }}</b> 님
				</p>
				<button class="logout" @click="onClickLogout">
					<span>로그아웃</span>
					<img src="@/assets/img/common/arrow_next.svg" alt="검색" loading="lazy" />
				</button>
			</div>
		</section>
		<section class="mainMenu">
			<div v-for="(depth1, depth1_idx) in mypageMenuList" :key="depth1_idx" class="depth1">
				<router-link :to="depth1.path" class="depth1_title" :class="{ on: currentMenuGroup === depth1.group }">
					{{ depth1.title }}
				</router-link>
			</div>
		</section>
	</nav>
</template>

<style lang="scss" scoped>
.mypage_menu {
	color: var(--color-base-white);
	max-width: 24rem;
	width: 100%;
	.user {
		.user_info {
			background-color: var(--color-bg-mid);
			border-radius: 1rem;
			display: flex;
			flex-direction: column;
			padding: 2rem;
			gap: 1.6rem;
			p {
				font-weight: var(--font-w-medium);
				font-size: var(--font-s-regular);
				line-height: 2.1rem;
				b {
					color: var(--color-primary);
				}
			}
			.logout {
				display: flex;
				font-weight: var(--font-w-regular);
				font-size: var(--font-s-mid);
				color: var(--color-base-light);
				line-height: 1.79rem;
				align-items: center;
				span {
					border-bottom: 1px solid var(--color-base-light);
				}
				img {
					width: 1.8rem;
					height: auto;
				}
			}
		}
	}
	.mainMenu {
		padding-top: var(--space-x-large);
		.mainTitle {
			font-size: var(--font-size-sm);
			font-weight: var(--font-w-semi-bold);
		}

		.depth1 {
			.depth1_title {
				display: flex;
				align-items: center;
				gap: 0.8rem;
				padding: var(--space-mid) 2rem;
				font-size: var(--font-s-regular);
				font-weight: var(--font-w-medium);
				line-height: 2.1rem;
				cursor: pointer;
				&.on {
					color: var(--color-primary);
				}
				.title_icon {
					align-items: center;
					display: flex;
					justify-content: center;
				}
			}
		}
	}
}
</style>
